import { useReport } from '../../context/ReportContext';

interface IChartStyleProps {
  showGridLines?: boolean;
  showYAxis?: boolean;
  showLegend?: boolean;
  sparseXLabels?: boolean;
}

/**
 * Column-layout chart defaults: single-series charts drop gridlines, y-axis
 * and legend; multi-series keep a legend and the reference grid. With the flag
 * off every chart keeps its own props, so this returns nothing to spread.
 */
export const useChartStyle = (seriesCount: number): IChartStyleProps => {
  const { columnLayout } = useReport();
  if (!columnLayout) return {};
  const single = seriesCount <= 1;
  return {
    sparseXLabels: true,
    showLegend: !single,
    showGridLines: !single,
    showYAxis: !single,
  };
};
